import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["fullScreen"],
      _excluded2 = ["fullScreen"],
      _excluded3 = ["fullScreen"],
      _excluded4 = ["fullScreen"];
import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    panel,
    width,
    height,
    fullScreen
  } = _ref;
  let cssRoot = {},
      cssWrapper = {},
      cssOverlay = {},
      cssHeader = {},
      cssHeaderInner = {},
      cssHeaderDock = {},
      cssBody = {},
      cssBodyContent = {},
      cssFooter = {};

  if (panel) {
    cssWrapper = panel.wrapper;
    cssOverlay = panel.overlay;
    cssHeaderDock = panel.headerDock;
    cssBody = panel.body;

    const _panel$root = panel.root,
          {
      fullScreen: coreFullScreenStyles
    } = _panel$root,
          commonRootStyles = _objectWithoutProperties(_panel$root, _excluded);

    cssRoot = safeMerge(commonRootStyles, {
      width,
      height
    });

    if (fullScreen) {
      cssRoot = safeMerge(cssRoot, coreFullScreenStyles);
    }

    const _panel$header = panel.header,
          {
      fullScreen: headerFullScreenStyles
    } = _panel$header,
          commonHeaderStyles = _objectWithoutProperties(_panel$header, _excluded2);

    cssHeader = commonHeaderStyles;

    if (fullScreen) {
      cssHeader = safeMerge(cssHeader, headerFullScreenStyles.outer);
      cssHeaderInner = headerFullScreenStyles.inner;
    }

    const _panel$bodyContent = panel.bodyContent,
          {
      fullScreen: bodyContentFullScreenStyles
    } = _panel$bodyContent,
          commonBodyContentStyles = _objectWithoutProperties(_panel$bodyContent, _excluded3);

    cssBodyContent = commonBodyContentStyles;

    if (fullScreen) {
      cssBodyContent = safeMerge(cssBodyContent, bodyContentFullScreenStyles);
    }

    const _panel$footer = panel.footer,
          {
      fullScreen: footerFullScreenStyles
    } = _panel$footer,
          commonFooterStyles = _objectWithoutProperties(_panel$footer, _excluded4);

    cssFooter = commonFooterStyles;

    if (fullScreen) {
      cssFooter = safeMerge(cssFooter, footerFullScreenStyles);
    }
  }

  return {
    cssOverlay,
    cssRoot,
    cssWrapper,
    cssHeader,
    cssHeaderInner,
    cssHeaderDock,
    cssBody,
    cssBodyContent,
    cssFooter
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    height,
    width,
    fullScreen
  } = _ref2;
  const panel = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.panel;
  return setTheme({
    panel,
    height,
    width,
    fullScreen
  });
}